import { prop, required } from "@rxweb/reactive-form-validators";
import { SaleAccountViewModel } from "../../../sale-account-management/add-sale-acount.model";
import { SaleOpportunity } from "../../opportunity.model";
import { ProfileDetailModel } from "../../../profile-management/profile-detail.model";
import { Contact as ContactForm } from 'src/app/shared/components/stand-alone-component/contact/contact.model';

/** Roles supported for a vendor participating in a proposal. */
export const PROFILE_VENDOR_ROLES = ['NO_ROLE', 'BOOKING_CONTACT', 'END_CLIENT', 'SIGNER'] as const;
/** Legacy role preserved for backward compatibility until DB migration is complete. */
export const LEGACY_BOOKING_CONTRACT_ROLE = 'BOOKING_CONTRACT';

export type ProfileVendorRole = typeof PROFILE_VENDOR_ROLES[number] | typeof LEGACY_BOOKING_CONTRACT_ROLE;

/** Human-readable labels for proposal vendor roles. */
export const PROFILE_VENDOR_ROLE_LABELS: Record<string, string> = {
    NO_ROLE: 'No Role',
    BOOKING_CONTACT: 'Booking Contact',
    BOOKING_CONTRACT: 'Booking Contact',
    END_CLIENT: 'End Client',
    SIGNER: 'Contract Signer',
};

/**
 * Normalizes vendor role string to canonical form, converting legacy BOOKING_CONTRACT to BOOKING_CONTACT.
 * @param role - Raw role string from backend or UI.
 * @returns Canonical role string.
 */
export function normalizeVendorRole(role: string): string {
    if (!role) return role;
    const upper = role.trim().toUpperCase();
    return upper === LEGACY_BOOKING_CONTRACT_ROLE ? 'BOOKING_CONTACT' : upper;
}

export class ProfileVendorModel{
    profileVendorId: number;
    profileId: string;
    profileType: string;
    vendorId: string;
    vendorType: string;
    @prop()
    @required()
    description: string;
    dateCreated: Date;
    dateDeleted: Date;
    dateModified: Date;
    contactPhone: string;
    contactEmail:string;
    roles: ProfileVendorRole[];
    isPrimary: boolean | null;
    replaceExistingSigner?: boolean;
    @prop()
    saleAccount: ProfileDetailModel;
}
